import { create } from 'zustand';
import { MarketIndicesDataType } from 'typings/dashboard.type';
import { getMarketIndicesAction } from './action';

type DashboardType = {
  getMarketIndicesAction: () => Promise<void>;
  marketIndicesLoading: boolean;
  marketIndicesError: boolean;
  marketIndices: MarketIndicesDataType;
  toggleFullScreenAction: (isFullScreen: boolean) => void;
  isFullScreen: boolean;
};

const useDashboardStore = create<DashboardType>((set) => ({
  marketIndices: null,
  marketIndicesLoading: false,
  marketIndicesError: false,
  getMarketIndicesAction: (): Promise<void> => getMarketIndicesAction(set),
  toggleFullScreenAction: (isFullScreen: boolean): void =>
    set({ isFullScreen }),
  isFullScreen: false,
}));

export default useDashboardStore;
